import { Component, inject } from '@angular/core';
import { TextsPipe } from '@app/pipes/texts.pipe';
import { FormAutofillService } from '@app/services/form-autofill.service';

/**
 * In-form "Mobiliar ID" autofill banner. Placed by an editor as a custom
 * webform element (`mobi_webform_login_banner`) wherever the personal-data
 * fields live. Self-hides when Mobiliar ID login is not configured.
 *
 * States (fields always stay visible and editable):
 *  - logged out: "Anmelden und automatisch ausfüllen" -> starts login and
 *    flags the intent so the form auto-fills once after the redirect returns.
 *  - signed in, not yet filled: "Automatisch ausfüllen" -> requests the fill.
 *  - signed in, already filled: re-fill state so the user can re-apply their
 *    profile (e.g. after manual edits).
 *
 * All state and actions come from the per-form FormAutofillService.
 */
@Component({
  selector: 'mobi-form-login-banner',
  standalone: true,
  imports: [TextsPipe],
  templateUrl: './form-login-banner.component.html',
})
export class FormLoginBannerComponent {
  #autofill = inject(FormAutofillService);

  readonly authEnabled = this.#autofill.authEnabled;
  readonly isAuthenticated = this.#autofill.isAuthenticated;
  readonly filled = this.#autofill.filled;

  onClick(): void {
    if (this.isAuthenticated()) {
      this.#autofill.requestFill();
    } else {
      this.#autofill.startLogin();
    }
  }
}
